import WIDGETS from './widgets';

export default {
	name: 'generate_template',
	spacing: 2,
	sx: { width: '100%', margin: '0px' },
	widgets: [{ content: WIDGETS.GENERATE_TEMPLATE, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
